import React from 'react';
import { Route, NavLink, Switch } from 'react-router-dom';
import { useRoutes, useSimulatorRoutes } from 'hooks';
import CircularLoader from 'components/common/CircularLoader';
import Cravings from '../Cravings';
import Lessons from '../Lessons';
import Overview from '../Overview';
import Rewards from '../Rewards';
import Calendar from '../Calendar';
import styles from './styles.module.scss';

interface IProps {
  isLoading: boolean;
}

const TabBar = (props: IProps) => {
  const { isLoading } = props;
  const routes = useRoutes();
  const simulatorRoutes = useSimulatorRoutes();
  return (
    <>
      <ul className={styles['tab-bar']} data-testid="tab-bar">
        <li data-testid="overview-tab">
          <NavLink
            to={simulatorRoutes.PATIENT_DASHBOARD_OVERVIEW}
            activeClassName={`${styles.active}`}
          >
            Overview
          </NavLink>
        </li>
        <li data-testid="lessons-tab">
          <NavLink
            to={simulatorRoutes.PATIENT_DASHBOARD_LESSONS}
            activeClassName={`${styles.active}`}
          >
            Lessons
          </NavLink>
        </li>
        <li data-testid="rewards-tab">
          <NavLink
            to={simulatorRoutes.PATIENT_DASHBOARD_REWARDS}
            activeClassName={`${styles.active}`}
          >
            Rewards
          </NavLink>
        </li>
        <li data-testid="calendar-tab">
          <NavLink
            to={simulatorRoutes.PATIENT_DASHBOARD_CALENDAR}
            activeClassName={`${styles.active}`}
          >
            Calendar
          </NavLink>
        </li>
        <li data-testid="cravings-tab">
          <NavLink
            to={simulatorRoutes.PATIENT_DASHBOARD_CRAVINGS}
            activeClassName={`${styles.active}`}
          >
            Cravings
          </NavLink>
        </li>
      </ul>
      <div className={styles.content}>
        <Switch>
          <Route
            path={routes.PATIENT_DASHBOARD_OVERVIEW}
            render={() => <Overview />}
          />
          <Route
            path={routes.PATIENT_DASHBOARD_LESSONS}
            render={({ location }) => <Lessons location={location} />}
          />
          <Route
            path={routes.PATIENT_DASHBOARD_REWARDS}
            render={() => <Rewards />}
          />
          <Route
            path={routes.PATIENT_DASHBOARD_CALENDAR}
            render={() => <Calendar />}
          />
          <Route
            path={routes.PATIENT_DASHBOARD_CRAVINGS}
            render={() => <Cravings />}
          />
        </Switch>
        {isLoading && (
          <div className={styles.loadingLayer}>
            <CircularLoader />
          </div>
        )}
      </div>
    </>
  );
};

export default TabBar;
